import React, { Component } from 'react'
import { mobileData } from '../const'
import logo from '../images/logo.jpeg'

export default class Footer extends Component {
    render() {
        return (
            <React.Fragment>
                <footer className="row footer-cust-padd">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="footer-logo-div text-center">
                                    <img src={logo} width="150px" />
                                </div>
                                <div className="commn-title-div text-center foot-title">
                                    {/* <h1>Watch On Time</h1> */}
                                </div>
                                <div className="foot-details text-center">
                                    <p>Gujarat</p>
                                    <a href={"tel:+" + mobileData.watchmarttMobile}>+{mobileData.watchmarttMobile}</a>
                                    <a href="mailto:watchmartt@gmail.com" className="d-block">watchmartt@gmail.com</a>
                                </div>

                            </div>
                        </div>
                    </div>

                </footer>
            </React.Fragment>
        )
    }
}
